import {FormControl, NgForm, NgModel} from '@angular/forms';
import {firstValueFrom} from 'rxjs';
import {MyHttpClient} from '../services/my-http-client.service';

export default class FormUtils {

    public static readonly EMAIL_PATTERN: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    public static readonly PASSWORD_PATTERN: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9\s]).{8,}$/;

    static hasSuccess(input: NgModel): boolean {
        return input ? (!input.invalid && (input.touched || input.dirty)) : false;
    }

    static hasError(input: NgModel): boolean {
        return input ? (input.invalid && (input.touched || input.dirty)) : false;
    }

    static resetValidation(control: FormControl): void {
        control.markAsPristine();
        control.markAsUntouched();
        control.updateValueAndValidity();
    }

    static async openDealerPortalProtectedLink(httpClient: MyHttpClient, url: string, dealerPortalSecurityToken: string): Promise<void> {
        const tabId: Window = window.open('about:blank', '_blank');
        const document: Document = tabId.document;

        const response: string = await firstValueFrom(
            httpClient.get(url, {
                headers: {'authToken': dealerPortalSecurityToken},
                responseType: 'text'
            })
        );

        document.open();
        document.write(response);
        document.close();
    }

    static revalidateForm(form: NgForm) {
        for (let controlsKey in form.controls) {
            form.controls[controlsKey].updateValueAndValidity({onlySelf: true, emitEvent: false});
            form.controls[controlsKey].markAsTouched();
        }
    }

}
